import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EngineeringPrecisionForIndustrialProgress from "./sections/EngineeringPrecisionForIndustrialProgress";
import TheEngineeringMindset from "./sections/TheEngineeringMindset";
import UnsereKarte from "./sections/UnsereKarte";
import PilaresAcademicos from "./sections/PilaresAcademicos";
import WhyWartmannUmzuege from "./sections/WhyWartmannUmzuege";
import News from "./sections/News";
import DirectSupport from "./sections/DirectSupport";
import InfoFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EngineeringPrecisionForIndustrialProgress />
      <TheEngineeringMindset />
      <UnsereKarte />
      <PilaresAcademicos />
      <WhyWartmannUmzuege />
      <News />
      <DirectSupport />
      <InfoFooter />
    </div>;
}